import { useEffect, useState } from 'react';


const useGetTemplateParameters = () => {

    const [value, setValue] = useState({});

    useEffect(() => {

        //for get slug
        let slug = window.location.pathname.replace('/', '')
        let dynamicServer =( window.location.href).split("?")[0];

    
        slug = slug.split("/").pop();
        dynamicServer = dynamicServer.replace(`/${slug}`, "").split("//")[1];


        //todo -> check this

        fetch(`https://${dynamicServer}/templates/json/${slug}.json`, {
        // fetch(`https://landing.getz.ir/templates/json/${slug}.json`, {
            headers: {

                'Cache-Control': 'no-cache',
            }
        })
            .then(data => data.json())
            .then(res => {

                const parseData = JSON.parse(res);
                window.document.title = parseData.baseAndMainTitle;
                setValue(parseData)

            })
            .catch(error => {

                console.log(error);
            })

    }, [])

    return [value, setValue]
};

export default useGetTemplateParameters;